module.exports = __webpack_public_path__ + "img/logo-101.c5963daf.png";